import React from 'react';
import { Box, FormControl, Typography, Select as MuiSelect, MenuItem, ListSubheader } from '@mui/material';
import { styles } from './TableColumnDropdowns.styles';

import { HIDE_COLUMN } from '../../../../stories/constants';
import { IModalMessages } from '../../../../types';

interface ITableColumnOption {
  id: string;
  name: string;
}

export interface ITableColumnDropdownsProps {
  selectedGroupings: string[];
  columnOptions: ITableColumnOption[];
  messages: IModalMessages;
  handleCreateTile(chartType: string, selectedGroupings?: string[]): void;
  setSelectedGroupings(categories: string[]): void;
}

interface ITableColumnDropdownsState {
  tableColumns: ITableColumnOption[];
  columnError: {
    message: any;
    class: string;
  };
}

export class TableColumnDropdowns extends React.Component<ITableColumnDropdownsProps, ITableColumnDropdownsState> {
  constructor(props) {
    super(props);

    // This is not the cleanest solution to set the initial tableColumns' state
    // We should refactor this so tableColumns is in the redux store instead of selectedGroupings
    // Then we should transform its data for relevant effects
    this.state = {
      tableColumns: [
        {
          id: this.props.selectedGroupings[0] || '',
          name: this.props.selectedGroupings[0] ? `FY${this.props.selectedGroupings[0]}` : ''
        },
        {
          id: this.props.selectedGroupings[1] || 'hide',
          name: this.props.selectedGroupings[1] ? `FY${this.props.selectedGroupings[1]}` : 'Hide Column'
        }
      ],
      columnError: {
        message: '',
        class: ''
      }
    };
  }

  handleCreateTableTile() {
    const { tableColumns } = this.state;
    const { setSelectedGroupings, handleCreateTile } = this.props;
    const selectedNewGroupings = this.getTableColumnNames(tableColumns);
    setSelectedGroupings(selectedNewGroupings);
    handleCreateTile('transparency_table', selectedNewGroupings);
  }

  compareColumnDropdownOptionsAndUpdateTableTile = (value, tableColumns, columnIndex) => {
    const oppositeColumnIndex = columnIndex === 0 ? 1 : 0;

    if (value.id !== null && value.id === tableColumns[oppositeColumnIndex].id) {
      this.setState({
        columnError: {
          message: <p className="hint whoops">Columns should have different values</p>,
          class: 'error'
        }
      });
    } else {
      const newTableColumns = [...tableColumns];
      newTableColumns[columnIndex] = {
        id: value.id,
        name: value.name
      };
      newTableColumns[oppositeColumnIndex] = {
        id: tableColumns[oppositeColumnIndex].id,
        name: tableColumns[oppositeColumnIndex].name
      };
      this.setState(
        {
          tableColumns: newTableColumns,
          columnError: {
            message: '',
            class: ''
          }
        },
        () => this.handleCreateTableTile()
      );
    }
  };

  onVisualizationSettingsColumn1Change = (value) => {
    const { tableColumns } = this.state;
    this.compareColumnDropdownOptionsAndUpdateTableTile(value, tableColumns, 0);
  };

  onVisualizationSettingsColumn2Change = (value) => {
    const { tableColumns } = this.state;
    this.compareColumnDropdownOptionsAndUpdateTableTile(value, tableColumns, 1);
  };

  getTableColumnNames = (tableColumns) => {
    const filteredTableColumns = tableColumns.filter(
      (column: ITableColumnOption) => column && column.id && column.id !== 'hide'
    );
    return filteredTableColumns.map((column: ITableColumnOption) => {
      return column.id;
    });
  };

  render() {
    const { messages, columnOptions } = this.props;
    const { columnError, tableColumns } = this.state;
    const column2Options = HIDE_COLUMN.concat(columnOptions);
    return (
      <Box>
        {
          <Box>
            <Box sx={styles.row}>
              <Box sx={styles.col}>
                <Typography component="span" sx={styles.label}>
                  {messages.column} 1
                </Typography>
                <FormControl fullWidth className="ui-form">
                  <MuiSelect
                    displayEmpty
                    sx={styles.select}
                    name="group-column1"
                    value={tableColumns[0].id ?? ''}
                    onChange={(event) => {
                      const selectedId = event.target.value as string;
                      const selected = columnOptions.find((o) => o.id === selectedId) || { id: null, name: '' };
                      this.onVisualizationSettingsColumn1Change(selected as any);
                    }}
                    className={columnError.class}
                    MenuProps={{ PaperProps: { sx: styles.menuPaper } }}
                  >
                    <ListSubheader>{messages.yearSelection}</ListSubheader>
                    {columnOptions.map((o) => (
                      <MenuItem key={o.id} value={o.id}>
                        {o.name}
                      </MenuItem>
                    ))}
                  </MuiSelect>
                </FormControl>
              </Box>
              <Box sx={styles.col}>
                <Typography component="span" sx={styles.label}>
                  {messages.column} 2
                </Typography>
                <FormControl fullWidth className="ui-form">
                  <MuiSelect
                    displayEmpty
                    sx={styles.select}
                    name="group-column2"
                    value={tableColumns[1].id ?? ''}
                    onChange={(event) => {
                      const selectedId = event.target.value as string;
                      const selected = column2Options.find((o) => o.id === selectedId) || { id: null, name: '' };
                      this.onVisualizationSettingsColumn2Change(selected as any);
                    }}
                    className={columnError.class}
                    MenuProps={{ PaperProps: { sx: styles.menuPaper } }}
                  >
                    {HIDE_COLUMN.map((o) => (
                      <MenuItem key={o.id} value={o.id}>
                        {o.name}
                      </MenuItem>
                    ))}
                    <ListSubheader>{messages.yearSelection}</ListSubheader>
                    {columnOptions.map((o) => (
                      <MenuItem key={o.id} value={o.id}>
                        {o.name}
                      </MenuItem>
                    ))}
                  </MuiSelect>
                </FormControl>
              </Box>
            </Box>
            {columnError.message}
          </Box>
        }
      </Box>
    );
  }
}
